import { RootState } from "@/store";

export const selectPortfolio = (state: RootState) => state.navigation.portfolio;
export const selectAccount = (state: RootState) => state.navigation.account;
export const selectQuoteAsset = (state: RootState) =>
  state.navigation.quoteAsset;
export const selectView = (state: RootState) => state.navigation.view;
export const selectSymbol = (state: RootState) => state.navigation.symbol;
